export default __webpack_public_path__ + "static/media/integration-background.13aa8adb.svg";